import { render } from "./TopUpModal.vue?vue&type=template&id=2e47b941&scoped=true"
import script from "./TopUpModal.vue?vue&type=script&lang=js"
export * from "./TopUpModal.vue?vue&type=script&lang=js"

import "./TopUpModal.vue?vue&type=style&index=0&id=2e47b941&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e47b941"]])

export default __exports__